import { render, staticRenderFns } from "./doctorGradeListserious.vue?vue&type=template&id=91cd1704"
import script from "./doctorGradeListserious.vue?vue&type=script&lang=js"
export * from "./doctorGradeListserious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports